var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFaqCall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.54,3c.06,.89,.21,1.76,.45,2.59l-1.2,1.2c-.41-1.2-.67-2.47-.76-3.79h1.51M14.4,15.02c.85,.24,1.72,.39,2.6,.45v1.49c-1.32-.09-2.59-.35-3.8-.75l1.2-1.19M5.5,1H2c-.55,0-1,.45-1,1,0,9.39,7.61,17,17,17,.55,0,1-.45,1-1v-3.49c0-.55-.45-1-1-1-1.24,0-2.45-.2-3.57-.57-.1-.04-.21-.05-.31-.05-.26,0-.51,.1-.71,.29l-2.2,2.2c-2.83-1.45-5.15-3.76-6.59-6.59l2.2-2.2c.28-.28,.36-.67,.25-1.02-.37-1.12-.57-2.32-.57-3.57,0-.55-.45-1-1-1Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqCall);
export default __webpack_public_path__ + "static/media/faq_call.854965413d4fa2d09356251a1fd2bad9.svg";
export { ForwardRef as ReactComponent };